import React, {useEffect, useState} from 'react';
import {logo} from "../helpers/img";
import {Link} from "react-router-dom";
import {
    LINK_ABOUT, LINK_BECOME_PARTNER,
    LINK_CAREER,
    LINK_CONTACT,
    LINK_HOME,
} from "../routes/type";
import {withTranslation} from "react-i18next";
import {APPNAME, getData, TECH_MAIL} from "../helpers/utils";
import LanguageSwitcher from "../components/Switcher/LanguageSwitcher";

const Footer = ({t}) => {

    const [data, setData] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            const result = await getData();
            setData(result);
        };

        fetchData();
    }, []);

    return (
        <footer className="bg-dark position-relative overflow-hidden pb-0 pt-6 pt-lg-8" data-bs-theme="dark">




            <div className="position-absolute top-0 end-0 mt-n3 me-n4" style={{opacity : "0.05"}}>
                <img src="/decoration-pattern-2.svg"  alt=""/>
            </div>

            <div className="container position-relative mt-5">
                <div className="row g-4 justify-content-between">


                    <div className="col-lg-3">
                        <Link className="me-0" to={LINK_HOME}>
                            <img className="light-mode-item h-40px" src={logo} alt={APPNAME}/>
                            <img className="dark-mode-item h-40px" src={logo} alt={APPNAME}/>
                        </Link>

                        <p className="mt-4 mb-2">A Bootstrap theme that's both stylish and functional, perfect for any
                            type of technology or corporate website.</p>
                    </div>



                    <div className="col-lg-8 col-xxl-7">
                        <div className="row g-4">

                            <div className="col-6 col-md-4">
                                <h6 className="mb-2 mb-md-4">{t('footer.quick_links')}</h6>
                                <ul className="nav flex-column">
                                    <li className="nav-item"><Link className="nav-link pt-0" to={LINK_ABOUT}>{t('menu.about')}</Link></li>
                                    <li className="nav-item"><Link className="nav-link" to={LINK_CONTACT}>{t('menu.contact')}</Link></li>
                                    <li className="nav-item"><Link className="nav-link" to={LINK_CAREER}>{t('menu.career')} <span className="badge text-bg-danger ms-2">2 Job</span></Link></li>
                                    <li className="nav-item"><Link className="nav-link" to={LINK_BECOME_PARTNER}>{t('menu.become_partner')}</Link></li>
                                </ul>
                            </div>


                            <div className="col-6 col-md-4">
                                <h6 className="mb-2 mb-md-4">Community</h6>
                                <ul className="nav flex-column">
                                    <li className="nav-item"><a className="nav-link pt-0" href="#">Documents</a></li>
                                    <li className="nav-item"><a className="nav-link" href="#">Privacy Policy</a></li>
                                    <li className="nav-item"><a className="nav-link" href="blog-grid.html">News and blogs</a></li>
                                    <li className="nav-item"><a className="nav-link" href="#">Terms & condition</a></li>
                                </ul>
                            </div>


                            <div className="col-md-4">

                                <h6 className="mb-2 mb-md-4">{t('footer.follow_on')}</h6>

                                <ul className="list-inline mb-0 mt-3">
                                    <li className="list-inline-item">
                                        <a className="btn btn-xs btn-icon btn-light" href={data?.facebook} target="_blank"><i className="fab fa-fw fa-facebook-f lh-base"></i></a>
                                    </li>
                                    <li className="list-inline-item">
                                        <a className="btn btn-xs btn-icon btn-light" href={data?.linkedin} target="_blank"><i className="fab fa-fw fa-linkedin-in lh-base"></i></a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                </div>

                <hr className="mt-4 mb-0"/>

                <div className="d-md-flex justify-content-between align-items-center text-center text-lg-start py-4">
                    <div className="text-body"> Copyrights ©2024 {APPNAME}.
                    </div>

                    <div className="dropdown dropup text-center text-md-end mt-3 mt-md-0">
                       <LanguageSwitcher />
                    </div>
                </div>
            </div>
        </footer>

    )
}

export default withTranslation()(Footer)